import { render, staticRenderFns } from "./turnos_dobles.vue?vue&type=template&id=0008929e&scoped=true&"
import script from "./turnos_dobles.vue?vue&type=script&lang=js&"
export * from "./turnos_dobles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0008929e",
  null
  
)

export default component.exports